import React from "react";
import "./ui.css";

export function LoadingState({ message = "Loading…" }) {
  return (
    <div className="ui-state">
      <span className="ui-state-spinner" role="status" aria-label="Loading" />
      {message && <p>{message}</p>}
    </div>
  );
}

export default LoadingState;
